import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header: {
    color: theme.palette.textcolor.main,
    textTransform: 'uppercase',
    fontSize: '1.4375em',
    fontStyle: 'italic',
    marginBottom: 10,
  },
  text: {
    color: '#000000',
  },
  filter: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 20,
    marginTop: 10,
    '@media (max-width: 750px)': {
      display: 'block',
    },
  },
  filterBy: {
    display: 'flex',
    alignItems: 'center',
    '& p': {
      fontStyle: 'italic',
      fontWeight: '600',
      fontSize: '1.1em',
      fontFamily: 'Source Sans Pro, sans-serif',
      [theme.breakpoints.down('xs')]: {
        fontSize: '1.1em',
      },
    },
  },
  toggles: {
    marginLeft: 20,
  },
  toggleItem: {
    border: 'none',
    backgroundColor: 'transparent',
    padding: 0,
    marginRight: 20,
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      position: 'relative',
      '&::after': {
        content: '""',
        position: 'absolute',
        display: 'block',
        bottom: -2,
        left: 0,
        width: '100%',
        height: 3,
        backgroundColor: theme.palette.primary.main,
      },
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '& p': {
        color: theme.palette.secondary.main,
      },
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '& p': {
      fontStyle: 'normal',
      color: '#36659C59',
    },
  },
  toggleText: {
    color: '#5C5C5C',
  },
  search: {
    position: 'relative',
    borderRadius: 5,
    border: '1px solid #C1C1BF',
    marginLeft: 0,
    width: '100%',
  },
  chartsWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  chartsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  chart: {
    width: '25%',
    textAlign: 'center',
    '@media (max-width: 1075px)': {
      width: '50%',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
    // '&.undefined': {
    //   [theme.breakpoints.down('xs')]: {
    //     width: '50%',
    //   },
    // },
  },
  chartTitle: {
    textTransform: 'uppercase',
    color: '#000000',
    fontFamily: 'Source Sans Pro, sans-serif',
    fontSize: 14,
  },
  legend: {
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: 400,
    marginBottom: 10,
  },
  legendLabel: {
    fontFamily: 'Source Sans Pro, sans-serif',
    display: 'block',
    position: 'relative',
    color: '#5C5C5C',
    margin: '0 20px',
    textTransform: 'uppercase',
    paddingLeft: 10,
    '&::after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 4,
      left: -10,
      width: 15,
      height: 15,
    },
  },
  legendWomen: {
    '&::after': {
      backgroundColor: '#BE7999',
    },
  },
  legendMen: {
    '&::after': {
      backgroundColor: '#9EBFCE',
    },
  },
  legendNonBinary: {
    '&::after': {
      backgroundColor: '#204635',
    },
  },
  donut: {
    position: 'relative',
    '& p': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -15,
      marginLeft: -40,
      width: 80,
    },
  },
}));

export default useStyles;
